const contentCard = {
  displayField: 'title',
  name: 'Content Card',
  description: '',
  fields: [
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'contentCard',
    version: 10,
    updatedAt: '2023-08-02T21:36:28.174Z'
  }
};
export default contentCard;